// lib/managers/graph/types/const.ts

export const graphApiUrl = "https://graph.microsoft.com/v1.0";

// Size of the batch for Graph API requests
export const BATCH_SIZE = 20;

// Delay between batches in milliseconds
export const BATCH_DELAY = 200;
